class Configuration {
    constructor() {
        this.FLAKE_BACK_END = process.env.REACT_APP_FLAKE_BACK_END;
        this.MIXPANEL_API_KEY = process.env.REACT_APP_MIXPANEL_API_KEY;
        this.FRESHCHAT_TOKEN = process.env.REACT_APP_FRESHCHAT_TOKEN;
    }
}
export const configuration = new Configuration();